import { useTranslations } from "next-intl";

export default function TranslateDomain({ domain }) {
    let name;
    const t = useTranslations();

    if (domain === "Tout") {
        name = t("filter_domain_all");
    } else if (domain == "Marketing") {
        name = t("filter_domain_marketing");
    } else if (domain == "Copywriting") {
        name = t("filter_domain_copywriting");
    } else if (domain == "SEO") {
        name = t("filter_domain_seo");
    } else if (domain == "Startup") {
        name = t("filter_domain_startup");
    } else if (domain == "Psychologie") {
        name = t("filter_domain_psychology");
    } else if (domain == "Ecommerce") {
        name = t("filter_domain_ecommerce");
    } else if (domain == "Design") {
        name = t("filter_domain_design");
    } else if (domain == "Programmation") {
        name = t("filter_domain_programming");
    }

    return <>{name}</>;
}
